export const FanLogAccessLevel = Object.freeze({
  ALL: 0,
  PRIVATE: 1,
});

export const FanLogAccessLevelOptions = Object.freeze([
  {
    value: FanLogAccessLevel.ALL,
    label: "공개",
  },
  {
    value: FanLogAccessLevel.PRIVATE,
    label: "비공개",
  },
]);
